const baseURL4 ="https://friendserp2.newfriendsjewellers.com:9095";



export default baseURL4;